export enum CLASS_SESSION_STATUS {
  LIVE = 'live',
  ENDED = 'ended'
}

export enum CLASS_PARTICIPANT_STATUS {
  INVITED = 'invited',
  JOINED = 'joined',
  DECLINED = 'declined',
  LEFT = 'left'
}

/** Mirrors the backend `BlockLevel` enum (focus-mode domain). */
export enum CLASS_BLOCK_LEVEL {
  GENTLE = 'gentle',
  STRICT = 'strict',
  SUPER_STRICT = 'super-strict'
}

/**
 * Per-session attendance classification (plan F3 attendance matrix — deferred).
 * Kept for StatusBadge / future term-level rollups. `null` on a session row
 * means not applicable (student enrolled after the session ran).
 */
export enum CLASS_ATTENDANCE {
  JOINED = 'joined',
  PARTIAL = 'partial',
  MISSED = 'missed'
}

/**
 * Canonical Pusher event names for class sessions.
 * Teachers receive these on `presence-class-<teamId>`; joined students also get
 * allowlist / tasks / ended (and invite / unlock-resolved) on `private-<userId>`.
 * Names are shared verbatim across backend / web / Mac / mobile
 * (see plans/teacher-mode.md, section A3).
 */
export enum CLASS_SESSION_EVENT {
  PARTICIPANT_UPDATED = 'class-participant-updated',
  ALLOWLIST_CHANGED = 'class-allowlist-changed',
  TASKS_UPDATED = 'class-session-tasks-updated',
  UNLOCK_REQUESTED = 'class-unlock-requested',
  SESSION_ENDED = 'class-session-ended'
}

/** PATCH session tasks failed because `expected_tasks_version` was stale. */
export enum SESSION_TASKS_AMEND_ERROR {
  VERSION_CONFLICT = 'version_conflict'
}

/**
 * Live roster "in focus now" cell display. Derived from join status +
 * heartbeat / app_offline fields (not a backend enum).
 */
export enum CLASS_IN_FOCUS_DISPLAY {
  DASH = 'dash',
  APP_OFFLINE = 'app_offline',
  CONNECTION_ISSUE = 'connection_issue',
  NO_HEARTBEAT = 'no_heartbeat',
  IN_FOCUS = 'in_focus',
  NOT_IN_FOCUS = 'not_in_focus'
}

/** Student ordered-tasks checklist row interaction state. */
export enum CLASS_ORDERED_TASK_ROW_STATE {
  COMPLETED_LOCKED = 'completed_locked',
  COMPLETED_LATEST = 'completed_latest',
  CURRENT = 'current',
  LOCKED_AHEAD = 'locked_ahead'
}

/** Presentational view status for the student ordered-tasks list. */
export enum CLASS_ORDERED_TASKS_VIEW_STATUS {
  LOADING = 'loading',
  READY = 'ready',
  EMPTY = 'empty',
  ERROR = 'error'
}
